export enum TicketStatus {
  OPEN = 2,
  PENDING = 3,
  RESOLVED = 4,
  CLOSED = 5,
  SCHEDULED = 7,
}
